import React from "react";
import { BoxProps } from "../Box";
import { Text } from "../Text";
import { StateFrame, StateIllustration } from "./styles";

export interface EmptyStateProps extends BoxProps {
  /** Headline, e.g. "No liquidity positions yet". */
  title: string;
  description?: string;
  /** Primary call to action (a Button or Link). */
  action?: React.ReactNode;
  /**
   * Illustration. The Business husky (`/images/brand/business.webp`) is allowed here and in
   * first-run intros only — never inside a live form or table. Omit for dense in-table empties.
   */
  illustration?: string;
  illustrationAlt?: string;
}

/**
 * True empty: normal styling, plain copy, optional character. Distinct from loading (no data yet)
 * and error (data unavailable).
 */
export const EmptyState: React.FC<React.PropsWithChildren<EmptyStateProps>> = ({
  title,
  description,
  action,
  illustration,
  illustrationAlt = "",
  children,
  ...props
}) => (
  <StateFrame {...props}>
    {illustration && <StateIllustration src={illustration} alt={illustrationAlt} loading="lazy" />}
    <Text bold fontSize="18px" as="h3" style={{ lineHeight: 1.3 }}>
      {title}
    </Text>
    {description && (
      <Text fontSize="15px" color="textSubtle" mt="6px" maxWidth="440px" style={{ lineHeight: 1.5 }}>
        {description}
      </Text>
    )}
    {children}
    {action && <div style={{ marginTop: 16 }}>{action}</div>}
  </StateFrame>
);

export default EmptyState;
